<template>
	<div class="vue-wrapper" v-if="$store.getters.isLoggedIn">
<lane-filters-mobile
			v-if="$store.state.isMobile"
			:columns="Columns"
			:totals="$store.getters[storeModule+'/getTotals']"
			:activeList="activeList"
			activeTabName="closures"
			:callOptionMethod="$store.getters[storeModule+'/getGrid'][this.activeList].statusLookup"
			v-on:update:status="onStatusUpdate"
			v-on:update:filters="onFilterArgUpdate"
			v-on:submit:filters="onSubmitFilters"
			:unreadMessagesCount="unreadMessagesCount"
			:unreadUpdatesCount="unreadUpdatesCount"
			v-on:lanefilters:togglemessages="onToggleMessages"
			v-on:lanefilters:toggleupdates="onToggleUpdates"
			v-on:submit:reportemergencyclosure="showEmergencyReportModal = true"
			:key="'lcc-filter-'+refreshNotificationId"
			v-on:update:refresh="fetchData"
			:title="title"
			:printing="printing"
			storeModule="reportClosureList"
			storeArgs="closureArgs"
			storeFilter="closureFilters"
			:showEmergencyClosureButton="true"
			:showEmergencyRestrictionButton="false"
			:showNewContraventionButton="false"
			:showPrintPdf="false"
			ref="filterRef"
		/>
<Lane-Filters
	v-if="!$store.state.isMobile"
	:columns="Columns"
	:totals="$store.getters[storeModule+'/getTotals']"
	:activeList="activeList"
	activeTabName="closures"
	:callOptionMethod="$store.getters[storeModule+'/getGrid'][this.activeList].statusLookup"
	v-on:update:status="onStatusUpdate"
	v-on:update:filters="onFilterArgUpdate"
	v-on:submit:filters="onSubmitFilters"
	:unreadMessagesCount="unreadMessagesCount"
	:unreadUpdatesCount="unreadUpdatesCount"
	v-on:lanefilters:togglemessages="onToggleMessages"
	v-on:lanefilters:toggleupdates="onToggleUpdates"
	:key="'lcc-filter-'+refreshNotificationId"
	v-on:submit:reportemergencyclosure="showEmergencyReportModal = true"
	v-on:update:refresh="fetchData"
	:title="title"
	:printing="printing"
	storeModule="reportClosureList"
	storeArgs="closureArgs"
	storeFilter="closureFilters"
	:showEmergencyClosureButton="true"
	:showEmergencyRestrictionButton="false"
	:showNewContraventionButton="false"
	:showPrintPdf="false"
	ref="filterRef"
/>
	<b-container class="laneclosure-list laneclosure-list-mobile wide">
		<div v-if="$store.state.isMobile" class="lane-closure-filters__title" :class="getFilterTitleClasses()">{{title}}</div>
		<b-modal centered id="report-emergency-closure-modal" title="Report Emergency Lane Closure" size="lg" v-model="showEmergencyReportModal" @ok="modalOnCancel()">
			<p class="is-size-6">In emergency situations that threaten public safety or are a public hazard, the Construction Agency responsible for the work performed is authorized to eliminate the public hazard immediately.</p>
			<template v-slot:modal-footer="{ ok }">
				<!-- <b-button variant="primary"  type="button" @click="modalOnSave">{{$t('labels.save')}} <b-spinner small label="Saving..." class="ml-2" v-if="saving"></b-spinner></b-button> -->
				<b-button variant="primary" type="button" @click="modalOnConfirm">{{$t('labels.reportEmergencyClosure')}}</b-button>
				<b-button variant="secondary"  type="button" @click="modalOnCancel">{{$t('labels.cancel')}}</b-button>
			</template>
		</b-modal>
		<slot>
			<!-- <hr style="margin: 0"/> -->
			<div class="column-grid lane-closure-table">
		<Spinner v-show="loading"/>
				<div :class="{'row-wrap': !$store.state.isMobile}">
					<div class="col-24 m24 xl24 t-header">
						<div class="row-wrap heading">
							<div class="col-24 gutter hide-on-med-and-down"
								v-for="(column, index) in $store.getters[storeModule+'/getGrid'][activeList].columns"
								:key="'irc'+index"
								:class="column.widths + ' col__' + column.key"
							>
								<caption class="column-title">
									<span v-text="column.alternateLabel ? column.alternateLabel : column.label" v-if="column.key != 'status'"></span>
									<b-form-select ref="filterRecordStatusId" v-if="column.key == 'status'" :options="LaneClosureRequest.getFilterLaneClosureRequestRecordStatusIdOptions" v-model="filterRecordStatusId.value"
									@input="onFilterRecordStatusId"
									:state="filterRecordStatusId.status"
									value-field="id"
									text-field="name"
									class="filter-record-status-id"
									size="sm"
									>

									</b-form-select>

									<img src="@/assets/sort-desc.svg"
										class="ctrl-arrow"
										alt="downarrow"
										:data-key="column.sortable ? column.key : null"
										v-show="column.sortable && showSortArrow(column, 'desc')"
										@click="onColumnChevronToggle"
										/>
									<img src="@/assets/sort-asc.svg"
										class="ctrl-arrow"
										alt="downarrow"
										:data-key="column.sortable ? column.key : null"
										v-show="column.sortable && showSortArrow(column, 'asc')"
										@click="onColumnChevronToggle"
										/>
									<img src="@/assets/sort-none.svg"
										class="ctrl-arrow"
										alt="downarrow"
										:data-key="column.sortable ? column.key : null"
										v-show="column.sortable && showSortArrow(column, '')"
										@click="onColumnChevronToggle"
										/>
								</caption>
							</div>
						</div>
						<div v-if="!$store.state.isMobile">
							<div v-for="(row, index) in Records" :key="'cii'+index+'-'+Math.random()"
								:class="`row-wrap records ${row.notification.color}-background`"
							>
								<div v-for="(column, i) in $store.getters[storeModule+'/getGrid'][activeList].columns" :key="'ciii'+i+'-'+Math.random()"
									:class="`col-24 ${column.widths} ${i < 1 ? (row.notification.color ? row.notification.color : (row.isEmergency ? 'red' : null)) : 'grey'}-border gutter` + ' col__' + column.key"
									:style="{ borderLeft: `${i < 1 ? '5px' : '0'} solid ${row.notification.color}` }"
								>
									<slot v-if="row[column.key]">
										<span class="hide-on-large-and-up" v-show="column.widths.indexOf('24') === -1">{{ column.alternateLabel ? column.alternateLabel : column.label }}: </span>
										<br class="hide-on-large-and-up" v-if="column.key === 'owner'"/>
										<div class="hide-on-med-and-down col-cta" @click="onRowSelected(index)">
											<slot v-if="(column.key).toUpperCase().indexOf('DATE') > -1">
												<span class="hide-on-med-and-down">
													<span v-html="strReplace(row[column.key], ' | ', '<br />')"></span>
												</span>
												<span class="hide-on-large-and-up" v-html="row[column.key]"></span>
											</slot>
											<slot v-else-if="column.key == 'affectedStreet'">
												<span v-html="row.affectedStreetFull"></span>
											</slot>
											<slot v-else>
												<span v-html="row[column.key]"></span>
											</slot>
										</div>
										<span class="hide-on-large-and-up col-cta" @click="onRowSelected(index)" v-html="row[column.key]"></span>
										<hr class="hide-on-large-and-up" v-if="column.separator" />
									</slot>
									<slot v-else>
										<a class="show-on-map" @click="showOnMap(index)" v-if="column.key === 'map'">
											<span class="on-container">
												<img class="on-badge responsive-img"
													src="@/assets/map-badge.svg"
													alt="on-badge"
												/>
												<img class="on-map responsive-img"
													src="@/assets/show-on-map.svg"
													alt="on-map"
													v-show="!row.mapShown"
												/>
												<img class="on-map responsive-img"
													src="@/assets/hide-map.svg"
													alt="on-map"
													v-show="row.mapShown"
												/>
											</span>
										</a>
									</slot>
								</div>
								<div class="col-24 l24 attention" :class="attentionBarClass(index)" v-show="displayAttentionBar(index)" @click="onRowSelected(index)">
									<div class="attention__background">
										<span v-show="row.unreadMessagesCount" style="display: inline-block" class="attention__unread-messages">
										<span v-show="row.unreadMessagesCount" class="badge badge-secondary"><span class="icon icon-message-circle"></span> {{row.unreadMessagesCount}}</span>
										</span>

									<span v-show="!isNewViolationNotificationText(row) &&  displayAttentionBarContravention(row.notificationEntries)"
											:class="displayAttentionBarEmergency(row) || displayAttentionBarUpdated(row.notificationEntries) ||
										  displayAttentionBarMessage(row.notificationEntries) || displayAttentionBarCallToAction(row.notification) ? ['attention__violation', 'border-right'] : ['attention__violation']"
											>New Violation</span>

									<span v-show="isNewViolationNotificationText(row) &&  displayAttentionBarContravention(row.notificationEntries)"
										:class="displayAttentionBarEmergency(row) || displayAttentionBarUpdated(row.notificationEntries) ||
										displayAttentionBarMessage(row.notificationEntries) || displayAttentionBarCallToAction(row.notification) ? ['attention__violation'] : ['attention__violation']"
										>New Violation</span>


										<span v-show="displayAttentionBarMessage(row.notificationEntries)"
										:class="displayAttentionBarEmergency(row) || displayAttentionBarUpdated(row.notificationEntries) || displayAttentionBarCallToAction(row.notification) ? ['attention__message', 'border-right'] : ['attention__message']"
											><img src="/img/nav/icon-messages-list.svg" alt="Messages" /> New Message</span>

									<span v-show="displayAttentionBarUpdated(row.notificationEntries)"
										:class="displayAttentionBarCallToAction(row.notification) ? ['attention__updated border-right'] : ['attention__updated']"
											>
									Updated Request
										</span>

									<span v-if="!isNewViolationNotificationText(row)" style="display: inline-block" v-show="displayAttentionBarCallToAction(row.notification)" :class="displayAttentionBarLcAndR(row) ? 'border-right' : ''">
											<img class="responsive-img hide-on-large-and-up" src="@/assets/downarrow.svg"/>
											<img src="/img/nav/icon-bell-circle.svg" alt="Updates" />
											{{ row.notification.text }}
										</span>
										<span style="display: inline-block" v-show="displayAttentionBarLcAndR(row)">
											<img class="responsive-img hide-on-large-and-up" src="@/assets/downarrow.svg"/>
											<img src="/img/nav/icon-bell-circle.svg" alt="Updates" />
											{{ attentionBarLcAndR(row) }}
										</span>
									</div>
								</div>
								<div class="col-24 l24 list-spacer hide-on-med-and-down"></div>
							</div>
						</div>
						<vue-pull-refresh v-if="false" :on-refresh="onRefresh" :config="pullRefreshConfig">
						</vue-pull-refresh>
						<div v-if="$store.state.isMobile">
							<div v-for="(row, index) in Records" :key="'ii'+index+'-'+Math.random()"
								:class="`records ${row.notification.color}-background-mobile`"
							>
								<lane-closure-block-mobile :record="row"></lane-closure-block-mobile>
							</div>
						</div>
						<div v-if="Records.length == 0 && !loading" class="mt-3">
							<h5>No Requests Found.</h5>
						</div>
					</div>
				</div>
			</div>
		</slot>
		<div class="paginateWrapper" v-show="!loading">
		<paginate
		:page-count="getPageCount"
		:page-range="3"
		:margin-pages="2"
		:click-handler="onPageClick"
		prev-text='<svg aria-hidden="true" focusable="false" data-prefix="fas" data-icon="chevron-left" role="img" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 320 512" class="svg-inline--fa fa-chevron-left fa-w-10"><path fill="currentColor" d="M34.52 239.03L228.87 44.69c9.37-9.37 24.57-9.37 33.94 0l22.67 22.67c9.36 9.36 9.37 24.52.04 33.9L131.49 256l154.02 154.75c9.34 9.38 9.32 24.54-.04 33.9l-22.67 22.67c-9.37 9.37-24.57 9.37-33.94 0L34.52 272.97c-9.37-9.37-9.37-24.57 0-33.94z" class=""></path></svg>'
		next-text='<svg aria-hidden="true" focusable="false" data-prefix="fas" data-icon="chevron-right" role="img" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 320 512" class="svg-inline--fa fa-chevron-right fa-w-10"><path fill="currentColor" d="M285.476 272.971L91.132 467.314c-9.373 9.373-24.569 9.373-33.941 0l-22.667-22.667c-9.357-9.357-9.375-24.522-.04-33.901L188.505 256 34.484 101.255c-9.335-9.379-9.317-24.544.04-33.901l22.667-22.667c9.373-9.373 24.569-9.373 33.941 0L285.475 239.03c9.373 9.372 9.373 24.568.001 33.941z" class=""></path></svg>'
		:container-class="'page-ctrl'"
		:page-class="'page'"
		:next-class="'page-next'"
		:prev-class="'page-prev'"
		ref="lcrPaginator"
		v-model="page"
		>
		</paginate>
		</div>
	</b-container>
	</div>
</template>

<script>
import LaneFilters from "./../../components/LaneFilters.vue";
import LaneFiltersMobile from "./../../components/LaneFiltersMobile.vue";
import LaneClosureBlockMobile from "./../../components/LaneClosureBlockMobile.vue";
import BootstrapField from './../../utility/BootstrapField';

import VuePullRefresh from 'vue-pull-refresh';

import Spinner from "./../../components/Spinner.vue"
import moment from 'moment-timezone'
import LaneClosureRequest from './../../models/LaneClosureRequest.js'
import Format from './../../utility/Format'
import KMLHelper from '../../utility/KMLHelper';
import Vue from 'vue'


export default {
	docTitle: "Approved Lane Closures",

	components: {
		'vue-pull-refresh': VuePullRefresh,
		'Lane-Filters': LaneFilters,
		LaneFiltersMobile,
		LaneClosureBlockMobile,
		Spinner,
	},
	mounted() {
		this.setEventBusOn();
		this.$nextTick(() => {
			this.$store.dispatch('map/setActiveLcrId', null);
			this.forceArgUpdate();
		});
	},
	created() {
		// this.fetchData()
	},
	data() {
		return {
			Format,
			pullRefreshConfig: {
                    errorLabel: "Error loading data...",
                    startLabel: "Loading...",
                    readyLabel: "Loading...",
                    loadingLabel: "Refreshing list...",
                },
			LaneClosureRequest:LaneClosureRequest,
			showMap: false,
			activeList: 0,
			ascOrder: true,
			loading: true,
			page: 0,
			lastIndex: null,
			rowMapToggle:[],
			Records:[],
			NearbyRecords:[],
			currentPage:1,
			filterRecordStatusId: new BootstrapField({
				value: null,
			}),
			title:'All Closures',
			printing: false,
			showRequiredFieldModal: false,
			modalRequiredFieldList: [],
			isButtonDisabled: false,
			refreshNotificationId:0,
			unreadMessagesCount: 0,
			unreadUpdatesCount: 0,
			storeModule:"reportClosureList",
			storeArgs:"closureArgs",
			showEmergencyReportModal:false,
			currentSort: ['', ''],
		}
	},
	computed: {
		getPageCount() {
			let pageCount = 1;
			if (this.$store) {
				let pagination = this.$store.getters[this.storeModule+'/getPagination'];
				if (pagination) {
					if (pagination.count) {
						pageCount = Math.ceil(pagination.count / pagination.perPage);
						if (pageCount < 1) {
							pageCount = 1;
						}

					}
				}
			}
			return pageCount;
		},
		getPage() {
			let page = 1;
			if (this.$store) {
				let pagination = this.$store.getters[this.storeModule+'/getPagination'];
				if (pagination) {
					if (pagination.page >= 1) {
						return pagination.page;
					}
				}
			}
			return page;
		},
		Columns() {
			return this.$store.getters[this.storeModule+'/getGrid'][this.activeList].columns
		},
	},
	beforeDestroy() {
		this.setEventBusOff();
	},
	methods: {
		getFilterTitleClasses() {
			if (this.title == "All Expired Requests Without Violations") {
				return "lane-closure-filters__title-small";
			}
			return null;
		},

		isNewViolationNotificationText(row) {
			if (row) {
				if (row.notification) {
					if (row.notification.text == "New Violation") {
						return true;
					}
				}
			}
			return false;
		},
		onRefresh() {
			return this.fetchData();
		},
		forceRerender() {
			this.renderCounter += 1;
		},
		setTitle() {
			var params = this.$store.getters[this.storeModule+'/getParams'];
			let title = "";
			let closureText = null;
			title = this.$store.getters[this.storeModule+'/getGrid'][this.activeList].title;
			if (typeof params.hasClosures == "undefined") {
				params.hasClosures = null;
			}
			if (typeof params.hasRestrictions == "undefined") {
				params.hasRestrictions = null;
			}
			if (params.hasClosures == null && params.hasRestrictions == null) {
				if (params.approvalStatusId == 1) {
					title = "Pending " + title;
				}
				if (params.approvalStatusId == 2) {
					title = "Approved " + title;

				}
				if (params.approvalStatusId == 3) {
					title = "Denied " + title;
				}
				if (params.showMine == 1) {
					title = "My " + title;
				} else {
					title = "All " + title;
				}
			}
			if (params.hasClosures == 1) {
				closureText = LaneClosureRequest.getActiveStatusText(params.closureActiveStatusId);
				if (closureText == null) {
					if (params.showMine == 1) {
						closureText = "My";
					} else {
						closureText	= "All";
					}
				} else {
					if (params.showMine == 1) {
						closureText = "My " + closureText;
					} else {
						closureText = "All " + closureText;
					}
				}
				title = closureText + " " + title;
			}
			if (params.hasRestrictions == 1) {
				closureText = LaneClosureRequest.getActiveStatusText(params.restrictionActiveStatusId);
				if (closureText == null) {
					if (params.showMine == 1) {
						closureText = "My";
					} else {
						closureText = "All";
					}
					closureText	= "All";
				} else {
					if (params.showMine == 1) {
						closureText = "My " + closureText;
					} else {
						closureText = "All " + closureText;
					}
				}
				title = closureText + " " + title;
			}
			if (typeof params.completed == "undefined") {
				// by default, we only want to see incomplete requests.
				params.completed = 0;
			}
			if (title == "Closures") {
				if (params.showMine == 1) {
					title = "My " + title;
				} else {
				title = "All " + title;
			}
			}
			this.title = title;
			return title;
		},
		friendlyDateFromNow(dt) {
			return Format.diffYMDHMSAgo(dt, new Date);
		},
		displayAttentionBar(index) {
			if (this.Records) {
				if (this.Records[index]) {
					if (this.Records[index].isEmergency) {
						return true;
					}
					if (this.Records[index].notification.text) {
						return true;
					}
					if (this.Records[index].unreadMessagesCount > 0) {
						return true;
					}
					if (this.Records[index].messageNotificationDate) {
						return true;
					}
					if (this.Records[index].modifiedNotificationDate) {
						return true;
					}
					if (this.Records[index].alertNotificationDate) {
						return true;
		}
					if (this.Records[index].contraventionNotificationDate) {
						return true;
					}
					if (this.Records[index].reminderNotificationDate) {
						return true;
					}
				}

			}
			return false;
		},
		attentionBarStyle(index) {
			if (this.Records) {
				if (this.Records[index]) {
					if (this.Records[index].notification) {
						return "{ backgroundColor:`dark${row.notification.color}` }";
					} else {
						return "{ background-color:#eee; }";
					}
				}
			}
			return "{ background-color:#eee; }";

	},
		attentionBarClass(index) {

			if (this.Records) {
				if (this.Records[index]) {
					if (this.Records[index].notification && this.Records[index].notification.typeId && this.Records[index].notification.color) {
							return "attention__type-" + this.Records[index].notification.typeId +" " +  this.Records[index].notification.color + "-border";
					} else if (this.Records[index].isEmergency) {
							return "attention__type-emergency red-border";
					} else {
							return "border";

					}
				}
			}
			return "";

		},


		setEventBusOff() {
			this.$bus.$off('update:pages', this.onPagePagination);
			this.$bus.$off('notification:refresh', this.onNotificationsRefresh);
			this.$bus.$off('map:shown', this.onMapShown);
			this.$bus.$off('filter:fetchData', this.fetchData);
			this.$bus.$off('map:hidden', this.onMapHidden);
		},
		setEventBusOn() {
			this.setEventBusOff();
			this.$bus.$on('filter:fetchData', this.fetchData);
			this.$bus.$on('update:pages', this.onPagePagination);
			this.$bus.$on('notification:refresh', this.onNotificationsRefresh);
			this.$bus.$on('map:shown', this.onMapShown);
			this.$bus.$on('map:hidden', this.onMapHidden);
		},
		onPageClick(value) {
			this.page = value
			this.$store.dispatch(this.storeModule+'/updateParams', { page: value } )
			this.fetchData()
		},
		modalOnConfirm(evt) {
			this.$router.push({name:"AddLaneClosureRequest", query:{isEmergency:1}});
		},
		modalOnCancel(evt) {
			this.showEmergencyReportModal = false;
		},

		onFilterRecordStatusId() {
		this.$store.dispatch(this.storeModule+'/updateParams', { recordStatusId: this.filterRecordStatusId.value} )
		this.fetchData()
	},

		onNotificationsRefresh() {
			// this.refreshNotificationId++;
			this.unreadUpdatesCount = this.$store.getters['notificationList/unreadUpdatesCount'];
			this.unreadMessagesCount = this.$store.getters['notificationList/unreadMessagesCount'];
			Vue.prototype.$bus.$emit("push:process-launch");
		},

		getToggleMapName(index) {
			return "list_toggle_map_"+index;
		},
		onSubmitFilters() {
			let argQuery = JSON.parse(localStorage.getItem(this.storeArgs))
			if (argQuery) {
				this.onFilterArgUpdate(argQuery)
			}
			this.$store.dispatch(this.storeModule+'/updateParams', { page: 1, closureActiveStatusId: null,hasClosures: 1} )

			this.fetchData()
		},
		onStatusUpdate(index, name = null) {
			// always show the first page of results when setting parameters
			let argQuery = JSON.parse(localStorage.getItem(this.storeArgs))
			if (argQuery) {
				this.$store.dispatch(this.storeModule+'/updateParams', argQuery )
			}


			this.$store.dispatch(this.storeModule+'/clearStatusFilters');
			this.$store.dispatch(this.storeModule+'/updateParams', { approvalStatusId: 2 } )
			this.$store.dispatch(this.storeModule+'/updateParams', { closureActiveStatusId: null } )
			this.$store.dispatch(this.storeModule+'/updateParams', { restrictionActiveStatusId: null } )
			this.$store.dispatch(this.storeModule+'/updateParams', { hasClosures: 1 } )
			this.$store.dispatch(this.storeModule+'/updateParams', { hasRestrictions: null } )
			this.$store.dispatch(this.storeModule+'/updateParams', { page: 1 } );
			this.activeList = index
			this.$store.dispatch(this.storeModule+'/updateParams', { page: 1,closureActiveStatusId: null,hasClosures: 1 } );
			if ( name ) {
				if (name == "planned") {
					this.$store.dispatch(this.storeModule+'/updateParams', { closureActiveStatusId: 1 } );
				}
				if (name == "active") {
					this.$store.dispatch(this.storeModule+'/updateParams', { closureActiveStatusId: 2 } );
				}
				if (name == "expired") {
					this.$store.dispatch(this.storeModule+'/updateParams', { closureActiveStatusId: 3 } );
				}
			}
			this.fetchData()
		},
		forceArgUpdate() {
			let argQuery = JSON.parse(localStorage.getItem(this.storeArgs))
			if (argQuery == null) {
				argQuery = {};
				argQuery.completed = 0;
			}
			argQuery.hasClosures = 1;
			argQuery.approvalStatusId = 2;

			let globalQuery = JSON.parse(localStorage.getItem(this.storeArgs))
			if (globalQuery) {
				argQuery.showMine = globalQuery.showMine;
			}

			if (argQuery) {
				this.onFilterArgUpdate(argQuery)
			}
			this.fetchData()
		},
		onFilterArgUpdate(queryArg) {
			this.$store.dispatch(this.storeModule+'/updateParams', { page: 1 } );
			this.$store.dispatch(this.storeModule+'/updateParams', queryArg )
		},
		onPagePagination(value) {
			this.page = value
			this.$store.dispatch(this.storeModule+'/updatePagination', { page: value } )
		},
		fetchData() {
			document.getElementById('main').scrollTo(0,0)

			if (!this.$store.getters.isLoggedIn) {
				return;
			}
			this.loading = true;
			this.lastIndex = null;
			this.$store.dispatch(this.storeModule+'/load', this.$store.getters[this.storeModule+'/getParams'])
				.then(() => {
					this.loading = false;

					if(this.$store.getters[this.storeModule+'/getParams'].recordStatusId) {
						if (this.filterRecordStatusId.value !=  this.$store.getters[this.storeModule+'/getParams'].recordStatusId) {
							this.filterRecordStatusId.value =  this.$store.getters[this.storeModule+'/getParams'].recordStatusId;
						}
					} else {
						this.filterRecordStatusId.value = null;
					}
						this.Records = [];
						let records = this.$store.getters[this.storeModule+'/getRecords'];
						if ( records ) {
							records.forEach( item => {
								let notificationProps = item.notification && Format.searchByKeyInArray(item.notification[0].notificationTypeId, 'id', LaneClosureRequest.getNotificationTypeIdOptions);

								let project = item.requesterProjectName ? item.requesterProjectName : ''
								let currentUser = this.$store.getters.userInfo();
								if (item.ownerId && item.ownerProjectName && currentUser.allUserOrganizations.includes(item.owner.organizationId)) {
									project = `<b>${item.ownerProjectName}</b>`;
								}

									// if (item.projectBidNumber != null) {
									// 	if (project == null || project == "null") {
									// 		project = "";
									// 	}
									// 	project += "Bid Op Number: "+item.projectBidNumber;
									// }

									// let activityStatusId = null
									// if ( callOptionMethod ) {
									//     activityStatusId = Format.searchByKeyInArray(item.activityStatusId, 'id', LaneClosureRequest[callOptionMethod]).name
									// }

								let statusText = "";
								let idAndRefText = "";
								let approvalText = "";
								let recordText = "";
								if(item.recordStatusId == 7) {
									// completed, so we don't need to see the rest...
									statusText = (item.recordStatusId ? Format.searchByKeyInArray(item.recordStatusId, 'id', LaneClosureRequest.getLaneClosureRequestRecordStatusIdOptions).name : '') +
									(item.completeTypeId ? " - " + LaneClosureRequest.getCompleteTypeIdText(item.completeTypeId): "");
								} else {
									approvalText = LaneClosureRequest.getApprovalStatusIdText(item.approvalStatusId);
									recordText = LaneClosureRequest.getRecordStatusText(item.recordStatusId);
									if (approvalText == recordText) {
										statusText = approvalText;
									} else {
										statusText = recordText + " - " + approvalText;
									}
								}
								var notificationObj = {
									date: null,
									typeId:  notificationProps && notificationProps.id,
									text: notificationProps && notificationProps.name,
									color: notificationProps && notificationProps.color
								}

								if (item.notification) {
									notificationObj.dateAgo = this.friendlyDateFromNow(item.notification[0].notificationDate);
									notificationObj.date = Format.toLocalDateTime(item.notification[0].notificationDate, "MMMM DD, YYYY H:mm");
									if (notificationObj.text) {
										notificationObj.text = notificationObj.text.formatUnicorn(item.id,Format.toLocalDateTime(item.fromDate, "MMM DD"),Format.toLocalDateTime(item.fromDate, "H:mm"),Format.toLocalDateTime(item.toDate, "MMM DD"),Format.toLocalDateTime(item.toDate, "H:mm"),notificationObj.date, moment(item.fromDate).fromNow(), moment(item.toDate).fromNow());
									} else {
										notificationObj.text = null;
									}
								}
								idAndRefText = "";
									if (item.trafficManagementRef != null) {
										idAndRefText += "TM: "+ item.trafficManagementRef + "<br/>";
									} else {
										idAndRefText += "TM: N/A<br/>";
										idAndRefText += "LCR: "+ item.id;
									}
								this.Records.push({
									id: item.id,
									altRequester: item.altRequester,
									altClosureReporter: item.altClosureReporter,
									closureReporter: item.closureReporter,
									requesterId: item.requesterId,
									altRestrictionReporter: item.altRestrictionReporter,
									requesterProjectName: project ? project : '',
									requesterProjectId: item.requesterProjectId,
									ownerProjectName:item.ownerProjectName,
									ownerProjectId: item.ownerProjectId,
									affectedStreetFull: this.parseLocation(item.affectedStreet, item.firstCrossStreet, item.lastCrossStreet, item.directionId, [], item.isUnderTwoHours, item.isEmergency), // don't show conflicts...
									affectedStreet: item.affectedStreet,
									firstCrossStreet: item.firstCrossStreet,
									lastCrossStreet: item.lastCrossStreet,
									trafficManagementRef: item.trafficManagementRef,
									idAndRef:idAndRefText,
									directionId: item.directionId,
									natureOfWorkId: item.natureOfWorkId,
									isUnderTwoHours:item.isUnderTwoHours,
									fromDate: item.fromDate,
									toDate:item.toDate,
									date: (item.fromDate ? Format.toLocalDateTime(item.fromDate, 'MM/DD/YYYY') : '') +
											(item.fromDate ? ` - ${Format.toLocalDateTime(item.toDate, 'MM/DD/YYYY')} | ` : '') +
											(item.fromDate ? Format.toLocalDateTime(item.fromDate, 'H:mm') : '') +
											(item.toDate ? ` - ${Format.toLocalDateTime(item.toDate, 'H:mm')}` : ''),
									status: statusText
										,
									block:item.block,
									owner: this.parseOwner(item),
									unreadMessagesCount: item.unreadMessagesCount,
									messageNotificationDate: item.messageNotificationDate,
									modifiedNotificationDate: item.modifiedNotificationDate,
									alertNotificationDate: item.alertNotificationDate,
									contraventionNotificationDate: item.contraventionNotificationDate,
									reminderNotificationDate: item.reminderNotificationDate,
									notification: notificationObj,
									notificationEntries: item.notification,
									mapShown:false,
									approvalStatusId: item.approvalStatusId,
									recordStatusId: item.recordStatusId,
									completeTypeId: item.completeTypeId,
									closureActiveStatusId: item.closureActiveStatusId,
									restrictionActiveStatusId: item.restrictionActiveStatusId,
									inEffect: item.inEffect,
									trafficEffect: item.trafficEffect,
									isEmergency: item.isEmergency,
									conflicts:[]
								});
							})
								this.$store.commit("map/clearMap", null);
								for (let x = 0; x < this.Records.length; x++) {
									if (this.Records[x].block) {
										for (let xx = 0; xx < this.Records[x].block.length; xx++) {
											this.setBlockPolyline(this.Records[x].block[xx], x);
										}
									}
								}
								this.$nextTick(() => {
									this.zoomAllBlocks();
								});
						}

						// don't need nearby...
						/*
						let nearbyRecords = this.$store.getters[this.storeModule+'/getNearbyRecords'];
						if ( nearbyRecords ) {
							nearbyRecords.forEach( item => {
								let notificationProps = item.notification && Format.searchByKeyInArray(item.notification[0].notificationTypeId, 'id', LaneClosureRequest.getNotificationTypeIdOptions);
								let project = item.requesterProjectName ? `${item.requesterProjectName}` : '';
								let currentUser = this.$store.getters.userInfo();
								if (item.owner) {
								if (item.ownerId && item.ownerProjectName && currentUser.allUserOrganizations.includes(item.owner.organizationId)) {
									project = `<b>${item.ownerProjectName}</b>`;
								}
								}
								let statusText = "";
								let idAndRefText = "";
								let approvalText = "";
								let recordText = "";
								if(item.recordStatusId == 7) {
									// completed, so we don't need to see the rest...
									statusText = (item.recordStatusId ? Format.searchByKeyInArray(item.recordStatusId, 'id', LaneClosureRequest.getLaneClosureRequestRecordStatusIdOptions).name : '') +
									(item.completeTypeId ? " - " + LaneClosureRequest.getCompleteTypeIdText(item.completeTypeId): "");
								} else {
									approvalText = LaneClosureRequest.getApprovalStatusIdText(item.approvalStatusId);
									recordText = LaneClosureRequest.getRecordStatusText(item.recordStatusId);
									if (approvalText == recordText) {
										statusText = approvalText;
									} else {
										statusText = recordText + " - " + approvalText;
									}
								}
								var notificationObj = {
									date: null,
									typeId:  notificationProps && notificationProps.id,
									text: notificationProps && notificationProps.name,
									color: notificationProps && notificationProps.color
								}
								if (item.notification) {
									notificationObj.dateAgo = this.friendlyDateFromNow(item.notification[0].notificationDate);
									notificationObj.date = Format.toLocalDateTime(item.notification[0].notificationDate, "MMMM DD, YYYY H:mm");
									if (notificationObj.text) {
										notificationObj.text = notificationObj.text.formatUnicorn(item.id,Format.toLocalDateTime(item.fromDate, "MMM DD"),Format.toLocalDateTime(item.fromDate, "H:mm"),Format.toLocalDateTime(item.toDate, "MMM DD"),Format.toLocalDateTime(item.toDate, "H:mm"),notificationObj.date, moment(item.fromDate).fromNow(), moment(item.toDate).fromNow());
									} else {
										notificationObj.text = null;
									}
								}
								idAndRefText = "";
									if (item.trafficManagementRef != null) {
										idAndRefText += "TM: "+ item.trafficManagementRef + "<br/>";
									} else {
										idAndRefText += "TM: N/A<br/>";
										idAndRefText += "LCR: "+ item.id;
									}
								this.NearbyRecords.push({
									id: item.id,
									altRequester: item.altRequester,
									altClosureReporter: item.altClosureReporter,
									closureReporter: item.closureReporter,
									requesterId: item.requesterId,
									altRestrictionReporter: item.altRestrictionReporter,
									requesterProjectName: project ? project : '',
									requesterProjectId: item.requesterProjectId,
									ownerProjectName:item.ownerProjectName,
									ownerProjectId: item.ownerProjectId,
									affectedStreetFull: this.parseLocation(item.affectedStreet, item.firstCrossStreet, item.lastCrossStreet, item.directionId, item.conflicts, item.isUnderTwoHours, item.isEmergency),
									affectedStreet: item.affectedStreet,
									firstCrossStreet: item.firstCrossStreet,
									lastCrossStreet: item.lastCrossStreet,
									trafficManagementRef: item.trafficManagementRef,
									natureOfWorkId: item.natureOfWorkId,
									isUnderTwoHours:item.isUnderTwoHours,
									idAndRef:idAndRefText,
									directionId: item.directionId,
									fromDate: item.fromDate,
									toDate:item.toDate,
									date: (item.fromDate ? Format.toLocalDateTime(item.fromDate, 'MM/DD/YYYY') : '') +
											(item.fromDate ? ` - ${Format.toLocalDateTime(item.toDate, 'MM/DD/YYYY')} | ` : '') +
											(item.fromDate ? Format.toLocalDateTime(item.fromDate, 'H:mm') : '') +
											(item.toDate ? ` - ${Format.toLocalDateTime(item.toDate, 'H:mm')}` : ''),
									status: statusText
										,
									block:item.block,
									owner: this.parseOwner(item),
									unreadMessagesCount: item.unreadMessagesCount,
									messageNotificationDate: item.messageNotificationDate,
									modifiedNotificationDate: item.modifiedNotificationDate,
									alertNotificationDate: item.alertNotificationDate,
									contraventionNotificationDate: item.contraventionNotificationDate,
									reminderNotificationDate: item.reminderNotificationDate,
									notification: notificationObj,
									notificationEntries: item.notification,
									mapShown:false,
									approvalStatusId: item.approvalStatusId,
									recordStatusId: item.recordStatusId,
									completeTypeId: item.completeTypeId,
									closureActiveStatusId: item.closureActiveStatusId,
									restrictionActiveStatusId: item.restrictionActiveStatusId,
									inEffect: item.inEffect,
									trafficEffect: item.trafficEffect,
									isEmergency: item.isEmergency,
									conflicts:item.conflicts
								});
							})
							for (let x = 0; x < this.NearbyRecords.length; x++) {
								if (this.NearbyRecords[x].block) {
									for (let xx = 0; xx < this.NearbyRecords[x].block.length; xx++) {
										this.setNearbyBlockPolyline(this.NearbyRecords[x].block[xx], x);
									}
						}
							}
						}
						*/
						this.$nextTick(() => {
							this.zoomAllBlocks();
						});




						this.setTitle();
						this.onNotificationsRefresh();
					})
				.catch( error => console.log('error', error) )
		},
		onRowSelected(index) {
			this.$router.push({name:"ReportClosure", params:{id:this.Records[index].id}});
		},
		onColumnChevronToggle(e, toggle = null) {
			e.preventDefault()
			if ( e.target.getAttribute('data-key') ) {
				// if ( this.$store.getters[this.storeModule+'/getParams'].sortBy !== e.target.getAttribute('data-key') ) {
				// 	this.$store.dispatch(this.storeModule+'/updateParams', { sortBy: e.target.getAttribute('data-key') } )
				// }
				// this.ascOrder = !this.ascOrder
				// this.ascOrder ? e.target.classList.add('asort') : e.target.classList.remove('asort')
				// this.$store.dispatch(this.storeModule+'/updateParams', { sortOrder: this.ascOrder ? 'asc' : 'desc' } )
				// this.fetchData()

				var dbKey = e.target.getAttribute('data-key');

				if (this.$store.getters[this.storeModule+'/getParams'].sortBy !== dbKey) {
					this.$store.dispatch(this.storeModule+'/updateParams', { sortBy: dbKey, sortOrder: 'asc' });
				} else {
					this.$store.dispatch(this.storeModule+'/updateParams', { sortOrder: this.$store.getters[this.storeModule+'/getParams'].sortOrder == 'asc' ? 'desc' : 'asc' });
				}
				this.$refs.filterRef.changeSortFromColumn(dbKey, this.$store.getters[this.storeModule+'/getParams'].sortOrder);

			} else {
				Vue.prototype.$bus.$emit("map:toggle", e, toggle)
			}
		},
		showSortArrow(column, order) {
			let sortBy = this.$store.getters[this.storeModule+"/getParams"].sortBy;
			let sortOrder = this.$store.getters[this.storeModule+"/getParams"].sortOrder;

			var dbKey = column.key;

			if (order == '' || order == null) {
				return dbKey != sortBy
			} else {
				return dbKey == sortBy && sortOrder == order
			}

		},
		onMapShown() {
		},
		onMapHidden() {
			// when clicked the hide map button on the map
			let i = 0;
			if (this.Records) {
				for (i = 0; i < this.Records.length; i++) {
					this.Records[i].mapShown = 0;
				}
			}
		},
		onToggleMessages(e, toggle = null) {
			Vue.prototype.$bus.$emit("notification:togglemessages", null);
		},
		onToggleUpdates(e, toggle = null) {
			Vue.prototype.$bus.$emit("notification:toggleupdates", null);
		},
		showOnMap(index) {
			if (index == this.lastIndex) {
				Vue.prototype.$bus.$emit("map:toggle", null, null);
				this.$nextTick(() => {
					this.zoomToLaneClosureRequest(this.Records[index].id);
					this.Records[index].mapShown = this.$mapShown;

				});
			} else {
				this.lastIndex = index;
				Vue.prototype.$bus.$emit("map:toggle", 1);
				Vue.prototype.$bus.$emit('map:close-street-view'); // close street view when switching between lane requests in lcr list view
				// this.$store.commit("map/clearMap", null);
				if (this.Records) {
					let xx = 0;
					if (this.Records[index].block) {
						for (xx = 0; xx < this.Records[index].block.length; xx++) {
							// this.setBlockPolyline(this.Records[index].block[xx], index);
						}
					}
					if (this.Records) {
						for (xx = 0; xx < this.Records.length; xx++) {
							if (index == xx)  {
								this.Records[xx].mapShown = 1;
							} else {
								this.Records[xx].mapShown = 0;
							}
						}
					}
				}
				this.$nextTick(() => {
					this.zoomToLaneClosureRequest(this.Records[index].id);

				});
		}

		},
		zoomAllBlocks(lcrId) {
			this.$store.dispatch("map/zoomAllBlocks", lcrId);
		},
		zoomToLaneClosureRequest(lcrId) {
			this.$store.dispatch("map/zoomToLaneClosureRequestId", lcrId);
		},
		setBlockPolyline(block, recordIndex) {
			let that = this;
			if (block) {
					var myParser = new Vue.prototype.$geoXML3.parser({map:null, afterParse: function(doc) {
						let xx = 0;
						var coords = [];
						let zz = 0;
						for (xx = 0; xx < doc[0].gpolylines[0].latLngs.length; xx++) {
							for (zz = 0; zz < doc[0].gpolylines[0].latLngs.getAt(xx).length; zz++) {
								coords.push(new google.maps.LatLng(doc[0].gpolylines[0].latLngs.getAt(xx).getAt(zz).lat(), doc[0].gpolylines[0].latLngs.getAt(xx).getAt(zz).lng()));
							}
						}

						let colour = "#000000";
						let opacity = 1.0;
						let weight = 8;

						if (that.Records[recordIndex].approvalStatusId == 1) {
							// pending
							colour = "#009900";
							opacity = 0.8;
							weight = 6;
						}
						if (that.Records[recordIndex].approvalStatusId == 2) {
							// active
							if (that.Records[recordIndex].closureActiveStatusId == 2 || that.Records[recordIndex].restrictionActiveStatusId == 2) {
								if (that.Records[recordIndex].block) {
									colour = "#ff7314";
									let i = 0;
									for (i = 0; i < that.Records[recordIndex].block.length; i++) {
										if (that.Records[recordIndex].block[i].lane) {
											for (let j = 0; j < that.Records[recordIndex].block[i].lane.length; j++) {
												// complete closure of street / direction
												if (that.Records[recordIndex].block[i].lane[j].laneId == 13 ||
													that.Records[recordIndex].block[i].lane[j].laneId == 14) {
													colour = "#ed1c24";
												}
											}
										}
									}
								}
							} else {
								// Approved and Planned (upcoming)
								if (that.Records[recordIndex].closureActiveStatusId == 1 || that.Records[recordIndex].restrictionActiveStatusId == 1) {
									colour = "#ffff00";
								}
							}


						}

						if (that.Records[recordIndex].recordStatusId == 6) {
							// expired
							colour = "#990000";
							opacity = 0.8;
							weight = 6;
						}

						if (that.Records[recordIndex].recordStatusId == 7) {
							// completed
							colour = "#666666";
							opacity = 0.8;
							weight = 6;
						}


						if (that.Records[recordIndex].approvalStatusId == 3) {
							// denied
						}
						var mapPolyline = new google.maps.Polyline({
						map: that.$store.state.map.map,
						path: coords,
						strokeColor: colour,
						strokeOpacity: opacity,
						strokeWeight: weight
						});
						mapPolyline.blockId = block.id;
						mapPolyline.blockData = block;
						mapPolyline.laneClosureRequest = that.Records[recordIndex];

						that.$store.commit("map/addNearbyPolyline", mapPolyline);
						google.maps.event.addListener(mapPolyline, 'click', function(e) {
							that.$bus.$emit('map:nearby-block-popup', {polyline:this, e:e});
						});
						return;
					}
					});
					let kmlString = "";
					if (block.kml != "") {
						let color = "7fff0000";
						kmlString += KMLHelper.createPlaceMarkFromGeometry(block.blockId, block.streetName, block.fromStreet, block.toStreet, block.kml, color, "8");
						kmlString = KMLHelper.finalizeKml(kmlString);
						myParser.parseKmlString(kmlString);
					}
				}
		},

		setNearbyBlockPolyline(block, recordIndex) {
			let that = this;
			if (block) {
					var myParser = new Vue.prototype.$geoXML3.parser({map:null, afterParse: function(doc) {
						let xx = 0;
						var coords = [];
						let zz = 0;
						for (xx = 0; xx < doc[0].gpolylines[0].latLngs.length; xx++) {
							for (zz = 0; zz < doc[0].gpolylines[0].latLngs.getAt(xx).length; zz++) {
								coords.push(new google.maps.LatLng(doc[0].gpolylines[0].latLngs.getAt(xx).getAt(zz).lat(), doc[0].gpolylines[0].latLngs.getAt(xx).getAt(zz).lng()));
							}
						}


						let colour = "#000000";
						let opacity = 1.0;
						let weight = 8;

						if (that.NearbyRecords[recordIndex].approvalStatusId == 1) {
							// pending
							colour = "#009900";
							opacity = 0.8;
							weight = 6;
						}
						if (that.NearbyRecords[recordIndex].approvalStatusId == 2) {
							// approved

							// see if any of the
							// active
							if (that.NearbyRecords[recordIndex].closureActiveStatusId == 2 || that.NearbyRecords[recordIndex].restrictionActiveStatusId == 2) {
								if (that.NearbyRecords[recordIndex].block) {
									colour = "#ff7314";
									let i = 0;
									for (i = 0; i < that.NearbyRecords[recordIndex].block.length; i++) {
										if (that.NearbyRecords[recordIndex].block[i].lane) {
											for (let j = 0; j < that.NearbyRecords[recordIndex].block[i].lane.length; j++) {
												// complete closure of street / direction
												if (that.NearbyRecords[recordIndex].block[i].lane[j].laneId == 13 ||
													that.NearbyRecords[recordIndex].block[i].lane[j].laneId == 14) {
													colour = "#ed1c24";
												}
											}
										}
									}
								}
							} else {
								// Approved and Planned (upcoming)
								if (that.NearbyRecords[recordIndex].closureActiveStatusId == 1 || that.NearbyRecords[recordIndex].restrictionActiveStatusId == 1) {
									colour = "#ffff00";
								}
							}


						}

						if (that.NearbyRecords[recordIndex].recordStatusId == 6) {
							// expired
							colour = "#990000";
							opacity = 0.8;
							weight = 6;
						}

						if (that.NearbyRecords[recordIndex].recordStatusId == 7) {
							// completed
							colour = "#666666";
							opacity = 0.8;
							weight = 6;
						}

						if (that.NearbyRecords[recordIndex].approvalStatusId == 3) {
							// denied
						}
						var mapPolyline = new google.maps.Polyline({
						map: that.$store.state.map.map,
						path: coords,
						strokeColor: colour,
						strokeOpacity: opacity,
						strokeWeight: weight
						});
						mapPolyline.blockId = block.id;
						mapPolyline.blockData = block;
						mapPolyline.laneClosureRequest = that.NearbyRecords[recordIndex];

						that.$store.commit("map/addNearbyPolyline", mapPolyline);
						google.maps.event.addListener(mapPolyline, 'click', function(e) {
							that.$bus.$emit('map:nearby-block-popup', {polyline:this, e:e});
						});
						return;
					}
					});
					let kmlString = "";
					if (block.kml != "") {
						let color = "7fff0000";
						kmlString += KMLHelper.createPlaceMarkFromGeometry(block.blockId, block.streetName, block.fromStreet, block.toStreet, block.kml, color, "8");
						kmlString = KMLHelper.finalizeKml(kmlString);
						myParser.parseKmlString(kmlString);
					}
				}
		},


		parseOwner(item) {
			// let requesterOrgTree;
			let requester = "";
			if (item.requester) {
				// requesterOrgTree = item.requester.organizationTree;
				// if (requesterOrgTree) {
				// 	requesterOrgTree = requesterOrgTree.split('|');
				// 	requesterOrgTree.pop();
				// 	requesterOrgTree.shift();
				// 	requesterOrgTree.reverse();
				// }
				// else {
				// 	requesterOrgTree = [item.requester.organizationName];
				// }
				requester += item.requester.organizationName;
				requester += "<br/>";
				requester += item.requester ? `${item.requester.firstName} ${item.requester.lastName}` : '';
			}
			// alternate = item.alternate ? `${item.alternate.firstName} ${item.alternate.lastName}<sup class="e-alternate"></sup><br class="hide-on-med-and-down"/>` : ''
			return requester;
		},
		parseLocation(loc1, loc2, loc3, directionId, conflicts, isUnderTwoHours, isEmergency) {
			let location = "";
			location += "<strong style='color:#293C7C;'>";
			if (directionId) {
				location += LaneClosureRequest.getDirectionAbbreviationText(directionId) + " ";
			}
			location += loc1 ? loc1 : ' '
			location += "</strong>";
			location = location && loc2 ? `${location}<br/>${loc2 ? loc2 : ' '}` : location
			location = location && loc3 ? `${location} to ${loc3 ? loc3 : ' '}` : location

			if (conflicts && conflicts.length > 0) {
				location += "<br />";
				if (isEmergency == 1) {
					location += "<span class='badge bg-emergency'>EMERGENCY</span> ";
				}
			// 	location += `<span class="badge bg-danger bg-conflict">${conflicts.length} Conflict${conflicts.length > 1 ? 's' : ''}</span>`;
				if (isUnderTwoHours == 1) {
					location += "<span class='badge bg-two-hours'>2 hours</span>";
				}
			} else {
					location += "<br />";
				if (isEmergency == 1) {
					location += "<span class='badge bg-emergency'>EMERGENCY</span> ";
				}
				if (isUnderTwoHours == 1) {
					location += "<span class='badge bg-two-hours'>2 hours</span>";
				}
			}


			return location
		},
		strReplace(string, searchValue, newValue) {
			if (typeof string === 'string') {
				return string.replace(searchValue, newValue)
			}
			return string
		},

		displayAttentionBarContravention(notification) {
			if (notification) {
				let contraventionNotifications = notification.filter(x => x.notificationTypeId == 'new-contravention');
				return contraventionNotifications.length > 0;
			}

			return false;
		},
		displayAttentionBarEmergency(row) {
			if (row) {
				return row.isEmergency;
			}

			return false;
		},
		displayAttentionBarUpdated(notification) {
			if (notification) {
					let updatedNotifications = notification.filter(x => x.notificationTypeId == 'lcr-updated');
					return updatedNotifications.length > 0;
				}

				return false;
		},
		displayAttentionBarMessage(notification) {
			if (notification) {
				let messageNotifications = notification.filter(x => ['lcr-new-message','new-message','contravention-new-message'].includes(x.notificationTypeId));
				return messageNotifications.length > 0;
			}

			return false;
		},
		displayAttentionBarCallToAction(notification) {
			if (notification) {
				return notification.text && !(notification.typeId == "lcr-new-message") && !(notification.typeId == "lcr-updated");
			}
			return false;
		},
		displayAttentionBarLcAndR(row) {
			if (row) {
				if (row.notification && (row.notification.typeId == "lc-not-opened" || row.notification.typeId == "r-not-removed")) {
					let notOpenedNotifications = row.notificationEntries.filter(x => x.notificationTypeId == "lc-not-opened");
					let notRemovedNotifications = row.notificationEntries.filter(x => x.notificationTypeId == "r-not-removed");

					return notOpenedNotifications.length > 0 && notRemovedNotifications > 0;
				}
			}

			return false;
		},
		attentionBarLcAndR(row) {
			if (row) {
				if (row.notification && row.notification.typeId == "lc-not-opened") {
					return Format.searchByKeyInArray('r-not-removed', 'id', LaneClosureRequest.getNotificationTypeIdOptions);
				} else if (row.notification && row.notification.typeId == "r-not-removed") {
					return Format.searchByKeyInArray('lc-not-opened', 'id', LaneClosureRequest.getNotificationTypeIdOptions);
				}
			}
		},
	},
	beforeRouteEnter(to, from, next) {
		next(vm => {
			Vue.prototype.$bus.$emit("map:clear", 1);
		});
	},
	beforeRouteLeave(to, from, next) {
		// store the
		this.$store.dispatch(this.storeModule+'/updateActiveIndex', this.activeList );
		this.$store.dispatch(this.storeModule+'/updateActiveTabName', this.activeTabName );
		Vue.prototype.$bus.$emit("map:clear", 1);
		next(true);
	},

}
</script>
